import { TakebackInboundDialogProps, TakebackInboundReturnData } from '../../../types/inbound'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import React, { useContext, useState } from 'react'
import { InputTextarea } from 'primereact/inputtextarea'
import { CommonContext } from '../../common/context/commonContext'
import SelectAbrogationDialog from './SelectAbrogationDialog'
import InputReturnDialog from './InputReturnDialog'
import { tokens } from 'locales/tokens'
import { useTranslation } from 'react-i18next'

const TakebackInboundDialog = (props: TakebackInboundDialogProps) => {
    const { $http, $toast } = useContext(CommonContext)
    const { t } = useTranslation()
    const [visibleAbrogation, setVisibleAbrogation] = useState<boolean>(false)
    const [visibleReturn, setVisibleReturn] = useState<boolean>(false)
    const onClickProssess = async (tkbckInbCd: 'GQ' | 'AB' | 'RET') => {
        switch (tkbckInbCd) {
            case 'GQ':
                await processTakeback('GQ')
                // $toast({ title: t(tokens.common.success), text: `회수 입고가 완료 되었습니다.`, icon: 'success' })
                break
            case 'AB':
                setVisibleAbrogation(true)
                break
            case 'RET':
                setVisibleReturn(true)
                break
        }
    }

    const processTakeback = async (tkbckInbCd: 'GQ' | 'AB' | 'RET', tkbckAbrgCd?: string, tkbckPrcsnTxt?: string) => {
        const result = await $http().put('/inbound/takeback', {
            tkbckUnitNo: props.info?.tkbckUnitNo,
            tkbckNo: props.info?.tkbckNo,
            seq: props.info?.seq,
            tkbckInbCd,
            tkbckAbrgCd,
            tkbckPrcsnTxt,
        })

        if (result && result.isProcess) {
            $toast({
                title: t(tokens.common.success),
                text: result.message,
                icon: 'success',
            })
            props.onHide && props.onHide()
        }
    }

    const onSelectAbrogation = async (tkbckAbrgCd: string) => {
        await processTakeback('AB', tkbckAbrgCd, ' ')
        setVisibleAbrogation(false)
    }

    const onChangeReturn = async (returnData: TakebackInboundReturnData) => {
        await processTakeback('RET', returnData.tkbckAbrgCd, returnData.tkbckPrcsnTxt)
        setVisibleReturn(false)
    }

    const footer = () => {
        // SALES
        return (
            <>
                <Button
                    className="w-full p-button-success"
                    label={t(tokens.inventory.quality_improvement)}
                    size="large"
                    onClick={() => onClickProssess('GQ')}
                />
                <Button
                    className="mt-1 w-full p-button-danger"
                    label="폐기"
                    size="large"
                    onClick={() => onClickProssess('AB')}
                    disabled={props.info?.sbjctRspnsCd === 'PURCHASE'}
                />
                <Button
                    className="mt-1 w-full p-button-secondary"
                    label={t(tokens.common.return_to_the_purchase)}
                    size="large"
                    onClick={() => onClickProssess('RET')}
                />
                <Button
                    className="mt-1 w-full p-button-secondary"
                    label={t(tokens.common.close)}
                    size="large"
                    onClick={() => props.onHide && props.onHide()}
                />
            </>
        )
    }

    return (
        <Dialog
            header={t(tokens.common.reception_details)}
            visible={props.visible}
            onHide={() => props.onHide && props.onHide()}
            closable={false}
            contentClassName="pb-0"
            footer={footer}
        >
            <div className="grid">
                <div className="col-12 flex mt-1">
                    <span className="text-primary font-bold">매출처명</span>
                    <span className="ml-2">{props.info?.spNm}</span>
                </div>
                <div className="col-12 flex">
                    <div className="col-6 pl-0 pt-0">
                        <span className="text-primary font-bold pt-0">요청 사유</span>
                        <span className="ml-2">{props.info?.rqstsNm}</span>
                    </div>
                    <div className="col-6 pt-0">
                        <span className="text-primary font-bold pt-0">귀책</span>
                        <span className="ml-2">{props.info?.sbjctRspnsNm}</span>
                    </div>
                </div>
                <div className="col-12 flex text-primary font-bold pt-0">
                    <span className="text-primary font-bold pt-0">상세 내용</span>
                </div>
                <div className="col-12 flex text-primary font-bold pt-0">
                    <InputTextarea value={props.info?.cnslnTxt} rows={9} className="text-sm w-full" readOnly />
                </div>
            </div>
            <SelectAbrogationDialog visible={visibleAbrogation} onSelect={onSelectAbrogation} onHide={() => setVisibleAbrogation(false)} />
            <InputReturnDialog visible={visibleReturn} onChange={onChangeReturn} onHide={() => setVisibleReturn(false)} />
        </Dialog>
    )
}

export default TakebackInboundDialog
